import type { ComponentProps } from "react";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

/** Normalize literal \n in API strings to real newlines so markdown lists/paragraphs parse. */
function normalizeNewlines(s: string): string {
  return s.replace(/\\n/g, "\n");
}

export function CaboMarkdown({ children, className }: { children?: string | null } & ComponentProps<"div">) {
  const source = typeof children === "string" ? normalizeNewlines(children) : (children ?? "");
  return (
    <Markdown
      components={{
        a: ({ children, ...props }) => {
          return (
            <a {...props} target="_blank" rel="noopener noreferrer" className="text-blue-550">
              {children}
            </a>
          );
        },
        p: ({ children, ...props }) => {
          return (
            <p {...props} className="mb-4">
              {children}
            </p>
          );
        },
        ul: ({ children, ...props }) => (
          <ul {...props} className="mb-4 list-disc pl-6">
            {children}
          </ul>
        ),
        ol: ({ children, ...props }) => (
          <ol {...props} className="mb-4 list-decimal pl-6">
            {children}
          </ol>
        ),
        li: ({ children, ...props }) => (
          <li {...props} className="mb-1">
            {children}
          </li>
        ),
      }}
      className={className}
      remarkPlugins={[remarkGfm, remarkBreaks]}
      rehypePlugins={[rehypeRaw]}
    >
      {source}
    </Markdown>
  );
}
